import React from 'react';

interface IProps {
    className: string;
    children: React.ReactNode;
}

const MainContent = ({ className, children } :IProps) => (
  <div className={className}>
    {children}
  </div>
);

export default MainContent;
